module.exports = __webpack_public_path__ + "images/skewness-10-desktop.png";